
export const acaoApi = Object.freeze({
  GRAVAR: 'gravar',
  REMOVER: 'remover'
});
